import React from 'react';
import MarkdownToJsx from 'markdown-to-jsx';
import styled from 'styled-components';
import { color } from '@ebay-certilogo/design-system-web/dist/shared/styles/themes/selectors';
import { margin, padding, lineHeight } from '@ebay-certilogo/design-system-web/dist/shared/styles';

// eslint-disable-next-line
const MyLink = ({ children, ...props }) => {
  // eslint-disable-next-line
  const target = (props.href.includes('http://') || props.href.includes('https://')) && '_blank';
  return (
    <a {...props} target={target}>
      {children}
    </a>
  );
};

const Markdown = styled(MarkdownToJsx).attrs({
  options: {
    overrides: {
      a: {
        component: MyLink,
      },
    },
  },
})`
  color: ${color};
  font-weight: inherit;
  ${lineHeight('base')}
  p {
    ${margin('s', 'bottom')}
  }
  ul,
  ol {
    ${margin('s', 'bottom')}
    ${padding('m', 'horizontal')}
    li {
      ${margin('s', 'bottom')}
    }
  }
  a {
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-all;
    word-break: break-word;
    hyphens: auto;
  }
  table {
    border-collapse: collapse;
    td,
    th {
      border-bottom: 1px solid;
      ${padding('s')}
    }
  }
`;

export default Markdown;
